module.exports = __webpack_public_path__ + "static/media/Meloetta_gaussian2.ba31bd18.png";